import { AxiosResponse } from 'axios';
import { CaseErrorsResponseData } from '../types';
import { apiToDomain } from './mapper';

const withCaseErrorMiddleware = (response: AxiosResponse<CaseErrorsResponseData>) => {
  const error = apiToDomain(response.data.error);
  return {
    ...response,
    data: {
      ...response.data,
      error,
    },
  };
};

export default withCaseErrorMiddleware;
